export default "__VITE_ASSET__CqIbePas__"